import React from 'react';
import PropTypes from 'prop-types';
import { FormRow } from '@here/ref-client-ui';
import CustomToggleButton from 'shared/toggleButton';
import './switchFormView.scss';

class SwitchFormView extends React.Component {
  onChange = ({ target: { checked } }) => {
    const {
      options: { key },
      fields,
      setFields,
    } = this.props;
    if (checked !== fields[key]) {
      setFields({ [key]: checked });
    }
  };

  render() {
    const {
      options: { key, label },
      fields,
    } = this.props;

    return (
      <FormRow>
        <div className="rf-switch-form-view">
          <div className="rf-switch-form-view__label">{label}</div>
          <CustomToggleButton
            checked={fields[key]}
            onChange={this.onChange}
          />
        </div>
      </FormRow>
    );
  }
}

SwitchFormView.propTypes = {
  fields: PropTypes.object,
  options: PropTypes.object,
  setFields: PropTypes.func.isRequired,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  parseUrl: ({ options: { initValue, key } }) => ({
    [key]: initValue || false,
  }),
  defaultState: (options) => {
    const { initValue, key } = options;
    return { [key]: initValue || false };
  },
  getRequestOptions: (fields, options) => {
    const { key } = options;
    if (!fields[key]) return {};
    
    // Convert preferMainRoads boolean to experimental parameter format
    if (key === 'preferMainRoads') {
      return {
        params: {
          'experimental[preferMainRoads]': fields[key] ? 'true' : 'false'
        }
      };
    }
    
    return {};
  },
  Component: SwitchFormView,
};